document.addEventListener("DOMContentLoaded", function () {
  const query = `
  query getProductsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        description
        availableForSale
        handle
        media(first: 1) {
          edges {
            node {
              mediaContentType
              ... on MediaImage {
                image {
                  src
                }
              }
            }
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
              sku
              price {
                amount
                currencyCode
              }
            }
          }
        }
        onlineStoreUrl
      }
    }
  }
  `;
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const api = window.location.origin + "/api/2023-07/graphql.json";

  if (wishlist.length === 0) {
    const wishlistContainer = document.querySelector(".wishlist-wrapper");
    const emptyMessage = document.createElement("h2");
    const emptyMessageDiv = document.createElement("div");
    emptyMessageDiv.classList.add("empty_wishlist");
    emptyMessage.textContent = "Wishlist is empty";
    emptyMessageDiv.appendChild(emptyMessage);
    wishlistContainer.appendChild(emptyMessageDiv);
    return;
  }
  const ids = wishlist.map((id) => `gid://shopify/Product/${id}`);
  const variables = {
    ids: ids,
  };

  const {
    companyId = null,
    locationId = null,
    customerId = null,
    iconId: iconTrashUrl = null,
    customPricingUrl = null,
  } = window.globalData || {};

  const xhr = new XMLHttpRequest();
  xhr.open("POST", api, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader(
    "X-Shopify-Storefront-Access-Token",
    "f8395ed0687fd9fbb2bf9a9f9644bd02"
  );

  xhr.onreadystatechange = async function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);
      const products = response.data.nodes;
      const productGrid = document.querySelector("#product-grid");

      for (let product of products) {
        if (product) {
          const sku = product.variants.edges[0].node.sku;
          const handle = product.handle;
          let productPrice = null;
          let pricingDataFetched = false;

          const carouselItem = document.createElement("li");
          carouselItem.classList.add("carousel-item");

          const carouselCard = document.createElement("div");
          carouselCard.classList.add("carousel-card");

          const header = document.createElement("div");
          header.classList.add("header");

          const imgContainer = document.createElement("div");
          const img = document.createElement("img");
          const imageSrc = product.media.edges[0].node.image?.src;

          if (imageSrc) {
            const imageElement = document.createElement("img");
            imageElement.src = imageSrc;
            imageElement.alt = product.title || "Product image";
            header.appendChild(imageElement);
          }


          const body = document.createElement("div");
          body.classList.add("body");
          
          const textSku = document.createElement("span");
          textSku.classList.add("product-sku");
          textSku.textContent = product.sku;
          
          const title = document.createElement("a");
          title.classList.add("product-title");
          title.href = product.onlineStoreUrl;
          title.textContent = product.title;
          
          const price = document.createElement("p");
          price.classList.add("price");
          if (product.variants.edges.length > 0) {
            const variant = product.variants.edges[0].node;
            price.textContent = `$${variant.price.amount}`;
          } else {
            price.textContent = "Price unavailable";
          }

          const wishlistIcon = document.createElement("div");
          wishlistIcon.classList.add("wishlist-icon-container")
          const actualProductId = product.id.match(/(\d+)$/)[0];
          wishlistIcon.innerHTML = `
          <a class="icon fa-stack fa-1x wishlist-button-collection" data-product-id="${ actualProductId }">
            <span class="fa-stack fa-1x">
              <i class="fa fa-square fa-stack-2x icon-background"></i>
              <i class="fa fa-heart-o fa-stack-1x"></i>
            </span>
          </a>
          `;

          const footer = document.createElement("div");
          footer.classList.add("footer");
          
          const buttonTemplate = product.availableForSale 
            ? document.querySelector("#button-template:not([data-modal])") 
            : document.querySelector("#button-template[data-modal]");
          
          if (buttonTemplate) {
            const clonedButton = buttonTemplate.cloneNode(true);
            
            const variantId = product.variants.edges[0]?.node.id || "";
            const actualVariantId = variantId.match(/(\d+)$/)[0];
          
            const productToCart = clonedButton.querySelector("product-to-cart");
          
            if (productToCart) {
              productToCart.setAttribute("variant-id", actualVariantId);
            }
          
            footer.appendChild(clonedButton);
          }
          

          const icon = document.createElement("div");
          icon.classList.add("icons");
          icon.innerHTML = `
            <a class="icon fa-stack fa-1x" href="${ product.onlineStoreUrl }">
              <span class="fa-stack fa-1x">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fa fa-search fa-stack-1x"></i>
              </span>
            </a>
            <a class="icon fa-stack fa-1x" href="#">
              <span class="fa-stack fa-1x">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fa fa-heart-o fa-stack-1x"></i>
              </span>
            </a>
            <a class="icon fa-stack fa-1x" href="#">
              <span class="fa-stack fa-1x">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fa fa-list-alt fa-stack-1x"></i>
              </span>
            </a>
          `;
          
          body.appendChild(textSku);
          body.appendChild(title);
          body.appendChild(price);

          carouselCard.appendChild(wishlistIcon);
          carouselCard.appendChild(header);
          carouselCard.appendChild(body);
          carouselCard.appendChild(footer);
          carouselCard.appendChild(icon);

          carouselItem.appendChild(carouselCard);
          productGrid.appendChild(carouselItem);
        }
      }
    }
  };

  xhr.onerror = function (err) {
    console.error("Error fetching products:", err);
  };

  xhr.send(
    JSON.stringify({
      query: query,
      variables: variables,
    })
  );
});